import React from "react";
import { Button, Tooltip } from "@material-ui/core";
import { FieldArray } from "formik";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { useFieldResourceStyles } from "../useFieldResourceStyles";
import { tokens } from "../../../../theme/tokens";

const EmptyFieldResourceState: React.FC = () => {
  const classes = useFieldResourceStyles();

  return (
    <div className={classes.emptyFieldResourceContainer}>
      <span>
        <Tooltip title="Add new field resource">
          <FieldArray name="case_detail.case_details.field_resource_information">
            {({ push }) => (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Button
                  startIcon={<AddCircleIcon style={{ fill: tokens.color.brand.primary }} />}
                  className={classes.localFieldResourceAddBtn}
                  style={{
                    marginTop: "0",
                    backgroundColor: tokens.color.surface.default,
                    color: tokens.color.brand.primaryAction,
                  }}
                  onClick={() => {
                    push({
                      id: "",
                      date_hired: "",
                      due_date: "",
                      hours_authorized: 0,
                      hours_billed: 0,
                      miles_billed: 0,
                      database_billed: 0,
                      report_received_date: "",
                      invoice_received_date: "",
                      invoice_approved_date: "",
                      rating: 0,
                    });
                  }}
                >
                  Add a Field Resource
                </Button>
              </div>
            )}
          </FieldArray>
        </Tooltip>
      </span>
    </div>
  );
};

export default EmptyFieldResourceState;
